<template>
	<div
		:id="id_name"
		@click="generate">
		<slot>
			{{button_text}}
		</slot>		
	</div> 	
</template>

<script>
import download from 'downloadjs'
import { numberWithCommas, formatDateFromISO } from "@/utils";

export default {	
	data: function(){
		return {
			animate   : true,
			animation : '',
			currentDate : '',						
		}
	},
	props: {
		'type' : {
			type: String,
			default: "xls"
		},
		'button_text': {
			type: String,
			default: "Download Excel"
		},
		'data':{
			type: Array,
			required: true
		},
		'param':{
			type: Object,
			required: true
		},
		'name':{
			type: String,
			default: "data.xls"
		},
		'meta':{
			type: Array,
			default: () => []
		},
		'columnName':{
			type: Array,
			default: () => []
		},
		'titleSheet':{
			type: String,
			default: ""			
		},						
	},
	created: function () {
		this.currentDate = new Date()		
	},
	computed:{
		id_name : function(){
			var date = new Date().getTime();
			return 'export_'+date;
		}
	},	
	methods: {
		commafy: function( num ) {
			var str = num.toString().split('.');
			if (str[0].length >= 5) {
				str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
			}
			if (str[1] && str[1].length >= 5) {
				str[1] = str[1].replace(/(\d{3})/g, '$1 ');
			}
			return str.join('.');
		},		
		generate() {
			if (this.type == 'csv') {
				return this.exportCSV(this.data, this.name, this.param);
			}
			else
			{
			return this.exportXLS(this.data, this.name, this.param);
			}
		},
		generate_excel: function () {
	    	this.exportXLS(this.data, this.name, this.param)
		},
		jsonToXLS: function (data, header) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table width="1000" border="1">${table}</table></body></html>'

			var xlsData = '', keys = []
			if (header) {
				xlsData += '<thead>'
				xlsData += '<tr>'
				xlsData += '<th align="left" colspan="9">' + this.titleSheet + '</th>'
				xlsData += '</tr>'
				xlsData += '<tr><th></th></tr>'
				xlsData += '<tr>'
				// for (var key in header) {
				// 	keys.push(key)
					
				// 	var columnNameArr = this.columnName;

				// 	var columnNameValue = columnNameArr.find(v => v.name == key).value;
				// 	var colspanValue = columnNameArr.find(v => v.name == key).colspan;

				// 	xlsData += '<th colspan="'+colspanValue+'">' + columnNameValue + '</th>';				
				// }

				var columnNameArr = this.columnName;

				header.forEach((column, index) => {
					keys.push(column)

					var columnNameValue = columnNameArr.find(v => v.name == column).value;
					var colspanValue = columnNameArr.find(v => v.name == column).colspan;

					xlsData += '<th colspan="'+colspanValue+'">' + columnNameValue + '</th>';
				});		
				
				xlsData += '</tr>'
				xlsData += '</thead>'
				xlsData += '<tbody>'

				data.map(function (item, index) {
					xlsData += '<tr>'
					for (var i = 0; i < keys.length; i++) {
						if (keys[i].indexOf(".") !== -1) {
							let keyNestedSplit = keys[i].split(".");
							let valueFromNestedKey = item[keyNestedSplit[0]];
						
							for (var j = 1; j < keyNestedSplit.length; j++) {
								valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
							}

							let colspanDetailValue = columnNameArr.find(v => v.name == keys[i]).colspan;
							let colType = columnNameArr.find(v => v.name == keys[i]).type;
							
							if(colType=="Number"){
								xlsData += '<td colspan="'+colspanDetailValue+'">' + numberWithCommas(item[keys[i]],2) + '</td>';
							}
							else if(colType=="DateTime")
							{
								xlsData += '<td colspan="'+colspanDetailValue+'">' + formatDateFromISO(item[keys[i]]) + '</td>';
							}
							else
							{
								xlsData += '<td colspan="'+colspanDetailValue+'">' + item[keys[i]] + '</td>';
							}
							
						} else {

							let colspanDetailValue = columnNameArr.find(v => v.name == keys[i]).colspan;
							let colType = columnNameArr.find(v => v.name == keys[i]).type;

							// xlsData += '<td colspan="'+colspanDetailValue+'">' + colType=="Number" ? numberWithCommas(valueFromNestedKey) : colType=="DateTime" ? formatDateFromISO(valueFromNestedKey) : valueFromNestedKey + '</td>';

							if(colType=="Number"){
								xlsData += '<td colspan="'+colspanDetailValue+'">' + numberWithCommas(item[keys[i]],2) + '</td>';
							}
							else if(colType=="DateTime")
							{
								xlsData += '<td colspan="'+colspanDetailValue+'">' + formatDateFromISO(item[keys[i]]) + '</td>';
							}
							else
							{
								xlsData += '<td colspan="'+colspanDetailValue+'">' + item[keys[i]] + '</td>';
							}			

						}
					}
					xlsData += '</tr>'
				})

				xlsData += '<tr>'
				var sumTotal = 0;

				for (var i = 0; i < keys.length; i++) {

					let colspanDetailValue = columnNameArr.find(v => v.name == keys[i]).colspan;
					let colType = columnNameArr.find(v => v.name == keys[i]).type;
					
					if(colType=="Number"){
						data.map(function (item, index) {
							for (var v = 0; v < keys.length; v++) {
								if(i == v){
									sumTotal = sumTotal + item[keys[v]];
								}			
							}
						});				
						xlsData += '<td colspan="'+colspanDetailValue+'">' + numberWithCommas(sumTotal,2) + '</td>';
					}else{
						xlsData += '<td colspan="'+colspanDetailValue+'">' + '' + '</td>';
					}
					sumTotal = 0;
				}

				xlsData += '</tr>'

				xlsData += '</tbody>'
				return xlsTemp.replace('${table}', xlsData)
			}
			data.map(function (item, index) {
				xlsData += '<tbody><tr>'
				for (var key in item) {
					xlsData += '<td>' + item[key] + '</td>'
				}
				xlsData += '</tr></tbody>'
			})
			return xlsTemp.replace('${table}', xlsData)
	  },
		jsonToCSV: function (data, header) {
			var csvData = ''
			
			if (header) {
				for (var key in header) {
					csvData +=  key + ','
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			}
			data.map(function (item) {
				for (const k in item) {
					let escapedCSV = item[k] + ''; // cast Numbers to string
				 	if (escapedCSV.match(/[,"\n]/)) {
            			 		escapedCSV = '"' + escapedCSV.replace(/"/g, "\"\"") + '"';
			         	}
				 	csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			return csvData
	  },
		base64: function (s) {
			return window.btoa(window.unescape(encodeURIComponent(s)))
		},
		exportXLS: function (data, fileName, header) {
			this.isLoading = true;
			var XLSData = 'data:application/vnd.ms-excel;base64,' + this.base64(this.jsonToXLS(data, header))
			this.download(XLSData, fileName, 'application/vnd.ms-excel')
			this.isLoading = false;
		},
		exportCSV: function (data, fileName, keys) {
			var CSVData = 'data:application/csv;base64,' + this.base64(this.jsonToCSV(data, keys))
			this.download(CSVData, fileName, 'application/csv')
		},
		base64ToBlob: function (base64Data) {
			var arr   = base64Data.split(',')
			var mime  = arr[0].match(/:(.*?);/)[1]
			var bstr  = atob(arr[1])
			var n     = bstr.length
			var u8arr = new Uint8ClampedArray(n)

			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], { type: mime })
		},
		download: function (base64data, fileName, fileType) {
			var blob       = this.base64ToBlob(base64data)

			download(blob, fileName, fileType)
		},
		numberWithCommas,
		formatDateFromISO,	
	}
}
</script>
